var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.8 21.6",
    style: {
      enableBackground: "new 0 0 23.8 21.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CF1F25;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000157293380631124000330000014588520995445894808_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,17.7L14.1,1.3c-0.7-1.2-2.3-1.7-3.5-1c-0.4,0.2-0.7,0.6-1,1L0.3,17.7c-0.7,1.2-0.3,2.8,1,3.5 c0.4,0.2,0.8,0.3,1.3,0.3h18.7c1.4,0,2.6-1.1,2.6-2.6C23.8,18.6,23.7,18.1,23.5,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.1,17.8c-0.3,0.2-0.6,0.4-1,0.4c-0.4,0-0.7-0.1-1-0.4c-0.3-0.3-0.5-0.7-0.4-1c0-0.8,0.6-1.4,1.4-1.4 c0,0,0,0,0,0c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1C13.5,17.2,13.3,17.6,13.1,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.4,8.3l-0.4,4.2c0,0.4-0.1,0.8-0.2,1.2c-0.1,0.3-0.4,0.5-0.8,0.5c-0.3,0-0.6-0.2-0.8-0.5 c-0.2-0.4-0.2-0.8-0.3-1.2l-0.3-4.1c-0.1-0.8-0.1-1.4-0.1-1.7c0-0.4,0.1-0.9,0.4-1.2C11.4,5.2,11.7,5,12.2,5 c0.5,0,0.9,0.2,1.1,0.7c0.2,0.5,0.3,1,0.3,1.5C13.5,7.6,13.5,8,13.4,8.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRed);
export default __webpack_public_path__ + "static/media/alert_red.1d5ed953036af294c10f50a85d8c00e9.svg";
export { ForwardRef as ReactComponent };